import type { VpIconName } from '@vtmn-play/react'
import type { ReactNode } from 'react'
import { SectionHeader } from './SectionHeader'

interface CategorySectionProps {
  title: string
  iconName?: VpIconName
  action?: ReactNode
  children: ReactNode
}

export function CategorySection({ title, iconName, action, children }: Readonly<CategorySectionProps>) {
  return (
    <div className="quick-search-results-page__section">
      <div className="quick-search-results-page__section-header-wrapper">
        <SectionHeader title={title} iconName={iconName} />
        {action}
      </div>
      {children}
    </div>
  )
}
